export default {
  username: "បញ្ចូលអក្សរនិងលេខចំនួន 3 តួ (0-9 A-Z) បន្សំគ្នា។",
  // password: "បញ្ចូលអក្សរនិងលេខចន្លោះពី 4 ដល់ 12 តួ (0-9 A-Z) បន្សំគ្នា។"
};